import { NgModule } from '@angular/core';

import { ColumnAlignmentPipe } from './column-alignment.pipe';
import { Nl2brPipe } from './nl2br.pipe';
import { RemoveNewlinePipe } from './remove-newline.pipe';
import { SafePipe } from './safe.pipe';
import { TypeofPipe } from './typeof.pipe';
import { YnPipe } from './yn.pipe';

@NgModule({
  declarations: [SafePipe, TypeofPipe, Nl2brPipe, RemoveNewlinePipe, ColumnAlignmentPipe, YnPipe],
  exports: [SafePipe, TypeofPipe, Nl2brPipe, RemoveNewlinePipe, ColumnAlignmentPipe, YnPipe],
})
export class PipeModule {}
